<template>
    <div>
        <h2>Ini page about</h2>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>

</style>